import React from 'react';
import { useNotificationContext } from "../../../../entities/notification/model";
import { SnackBar } from "../../../../shared/ui";
import { useScrollContext } from "../../../../shared/model";
export var Notifications = function Notifications() {
  var _useNotificationConte = useNotificationContext(),
    notifications = _useNotificationConte.notifications,
    removeNotification = _useNotificationConte.removeNotification;
  var _useScrollContext = useScrollContext(),
    scrollRef = _useScrollContext.scrollRef;
  return /*#__PURE__*/React.createElement(SnackBar, {
    align: "tabbar",
    autoCloseTime: 5000,
    container: scrollRef.current || undefined,
    getItemId: function getItemId(item) {
      return item.key;
    },
    getItemSubTitle: function getItemSubTitle(item) {
      return item.subTitle;
    },
    getItemTitle: function getItemTitle(item) {
      return item.label;
    },
    getItemView: function getItemView(item) {
      return item.view;
    },
    items: notifications,
    onItemClose: function onItemClose(item) {
      return removeNotification(item.key);
    },
    "data-t-id": "ui-Notifications"
  });
};